/**
 * Mosaico cover sizing.
 *
 * For grid-containers using the "Mosaico" block style, each tile image must FILL
 * its cell while keeping its natural aspect ratio as the <img> box (so the native
 * core/image lightbox enlarges the full, uncropped image — see style.scss).
 *
 * CSS alone can't choose which axis to pin to 100% for a generic image/cell ratio,
 * so we do it here: pin the width when the image is "taller" than the cell, else
 * pin the height. The figure (overflow: hidden) clips the overflow.
 */
const MOSAIC_SELECTOR =
	'.wp-block-improntad-blocks-grid-container.is-style-mosaic .wp-block-image > img';
const RESIZE_DEBOUNCE_MS = 150;

function coverImage(img) {
  const figure = img.closest('.wp-block-image');
  if (!figure) {return;}

  const cellWidth = figure.clientWidth;
  const cellHeight = figure.clientHeight;
  const naturalWidth = img.naturalWidth;
  const naturalHeight = img.naturalHeight;
  if (!cellWidth || !cellHeight || !naturalWidth || !naturalHeight) {return;}

  const imageIsTallerThanCell =
		naturalWidth / naturalHeight <= cellWidth / cellHeight;

  if (imageIsTallerThanCell) {
    img.style.inlineSize = '100%';
    img.style.blockSize = 'auto';
  } else {
    img.style.inlineSize = 'auto';
    img.style.blockSize = '100%';
  }
}

function init() {
  const images = document.querySelectorAll(MOSAIC_SELECTOR);
  if (!images.length) {return;}

  images.forEach((img) => {
    if (img.complete) {coverImage(img);}
    else {img.addEventListener('load', () => coverImage(img));}
  });

  let resizeTimer;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(
      () => images.forEach(coverImage),
      RESIZE_DEBOUNCE_MS
    );
  });
}

if (document.readyState !== 'loading') {init();}
else {document.addEventListener('DOMContentLoaded', init);}
